var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onboarding-animation",class:{ small: _vm.imageId === 'plant' }},[(_vm.image)?_c(_vm.image,{tag:"Component",class:_vm.imageId}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }